import { isNil } from 'lodash-es'

import { isAccountActive } from './customerAccount'
import {
  CustomerAccount,
  PaymentMethod,
  PaymentMethodStatus,
  PaymentMethodType,
} from './types'

export const getUsablePaymentMethod = (
  paymentMethods: PaymentMethod[] | undefined,
  type: PaymentMethodType,
): PaymentMethod | undefined =>
  paymentMethods?.find(
    (paymentMethod) =>
      paymentMethod.type === type &&
      [
        PaymentMethodStatus.ACTIVE,
        PaymentMethodStatus.PENDING_CUSTOMER_APPROVAL,
      ].includes(paymentMethod.status),
  )

export const hasActiveAccountsWithPaymentMethod = (
  customerAccounts: CustomerAccount[],
  type: PaymentMethodType,
): boolean =>
  customerAccounts.some((it) => isAccountActive(it) && it.paymentMethodType === type)

export const hasMissingPaymentMethod = (
  customerAccounts: CustomerAccount[],
  paymentMethods: PaymentMethod[],
  type: PaymentMethodType,
): boolean =>
  hasActiveAccountsWithPaymentMethod(customerAccounts, type) &&
  !getUsablePaymentMethod(paymentMethods, type)

export const getAccountUsablePaymentMethod = (
  paymentMethods: PaymentMethod[],
  type: PaymentMethodType | undefined,
  accountCode: string,
) => {
  if (isNil(type)) {
    return undefined
  }

  return (
    paymentMethods.find(isUsablePaymentMethod(type, accountCode)) ??
    paymentMethods.find(isUsablePaymentMethod(type))
  )
}

export const isUsablePaymentMethod =
  (type: PaymentMethodType, policyNumber: string | null = null) =>
  (paymentMethod: PaymentMethod) =>
    paymentMethod.accountCode === policyNumber &&
    type === paymentMethod.type &&
    [PaymentMethodStatus.ACTIVE, PaymentMethodStatus.PENDING_CUSTOMER_APPROVAL].includes(
      paymentMethod.status,
    )
